import { render, staticRenderFns } from "./GameOver.vue?vue&type=template&id=397716b9&scoped=true&"
import script from "./GameOver.vue?vue&type=script&lang=js&"
export * from "./GameOver.vue?vue&type=script&lang=js&"
import style0 from "./GameOver.vue?vue&type=style&index=0&id=397716b9&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "397716b9",
  null
  
)

component.options.__file = "GameOver.vue"
export default component.exports